import { fetchApi } from "../fetchApi";

export async function get_installed({
  args = [],
  model,
  method,
  context = {},
  company_id,
  endpoint = "/web/dataset/call_kw/res.lang/get_installed",
  params = null,
} = {}) {
  const { lang = false, tz = false, uid = false, ...restContext } = context;
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: params || {
      args,
      kwargs: { context },
      model: model,
      method,
    },
  });

  try {
    const requestOptions = {
      method: "POST",
      body: raw,
      redirect: "follow",
    };
    const reaponse = await fetchApi({
      requestOptions,
      endpoint,
    });
    return JSON.parse(reaponse);
  } catch (error) {
    return error;
  }
}
